export const formatSortCode = (sortCode: string): string => {
    const cleaned = sortCode.replace(/-/g, '')

    if (!/^\d{6}$/.test(cleaned)) {
        throw new Error('Invalid sort code format. Must be 6 digits.')
    }

    return cleaned.replace(/(\d{2})(\d{2})(\d{2})/, '$1-$2-$3')
}
